<template>
	<div class="offer-details-catalogue-modal">
		<BaseModal
			:label="translate('offer.details')"
			with-open-button
			:header-title="translate('offer.details')"
			:open-button-props="{
				label: translate('offer.details'),
				bold: true,
			}"
			full-height
			@open="$emit('catalogueModalOpen')"
		>
			<Loading
				v-if="isLoading"
				unique-key="catalogue"
				class="offer-details-catalogue-modal__catalogue-loading"
			/>
			<CatalogueInfo
				v-else-if="catalogueInfoData && !isLoading"
				:catalogue-info="catalogueInfoData"
				:client="client"
				class="offer-details-catalogue-modal__catalogue-info"
				@operator-changed="$emit('operatorChange', $event)"
			/>
		</BaseModal>
	</div>
</template>
<script lang="ts" setup>
import type { ClientType } from '@/interfaces/common';
import type { HotelCatalogueType } from '@/interfaces/hotel-catalogue-types';
import { determineClient } from '@/js/utils/environmentUtils';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import CatalogueInfo from '@lmt-rpb/CatalogueInfo/CatalogueInfo.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { useTranslations } from 'src/storybook/src/composables/translations';
interface Props {
	catalogueInfoData: HotelCatalogueType | null;
	client: ClientType;
	isLoading?: boolean;
}
const { client = determineClient() } = defineProps<Props>();
defineEmits<{ operatorChange: [code: string]; catalogueModalOpen: [] }>();

const { translate } = useTranslations();
</script>
<style lang="scss" scoped>
.offer-details-catalogue-modal {
	&__catalogue-loading {
		margin: 0 auto;
	}
}
</style>
